import React from "react"

import {
    Grid,
    Stack,
} from "@mui/material"

import {
    MatesSelect,
    MatesSwitch,
    MatesTextField,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import { UseFormReturn } from "react-hook-form"
import {t, Trans} from "@lingui/macro"

import {
    AssetFilter,
    AssetType,
    ContractType,
    PositionType,
} from "models"
import { AdvancedSearchbar } from "components/advanced-searchbar"

import FavouritesAdvancedSearchSchema, { FavouritesAdvancedSearchForm } from "./form"
import {AssetAdvancedSearchForm} from "../../asset/advanced-search/form";

interface FavouritesAdvancedSearchProps extends UseFormReturn
{
    handleCallback: (request: AssetFilter) => void
}
class FavouritesAdvancedSearch extends React.Component<FavouritesAdvancedSearchProps, {}>
{

    private onSearch = (data: Record<string, any>): void => {
        const formData: AssetAdvancedSearchForm = new AssetAdvancedSearchForm()
        Object.assign(formData, data)

        const request: AssetFilter = formData.toRequest()
        this.props.handleCallback(request)
    }

    render()
    {
        return (
            <AdvancedSearchbar
                {...this.props}
                searchFieldName="address"
                searchFieldPlaceholder={t({id: "favourite-advanced-search.address", message: "Ricerca per indirizzo"})}
                onSearch={this.onSearch}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <MatesSelect
                            name="position"
                            label="Posizione"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(PositionType).map(positionKey =>
                                <option value={positionKey}>
                                    <Trans id={`enums.asset-position.${positionKey}`}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MatesSelect
                            name="assetType"
                            label="Tipo"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(AssetType)
                                .map(type =>
                                    <option value={type}>
                                        <Trans id={`enums.asset-types.${type}`}>
                                        </Trans>
                                    </option>
                                )
                            }
                        </MatesSelect>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <MatesTextField
                            name="shopWindows"
                            label="Numero di vetrine"
                            variant="outlined"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <MatesSelect
                            name="contractType"
                            label="Tipo di contratto"
                            variant="outlined"
                            formState={this.props.formState}
                            control={this.props.control}
                            trigger={this.props.trigger}>
                            {Object.keys(ContractType).map(typeKey =>
                                <option value={typeKey}>
                                    <Trans id={`enums.contract-type.${typeKey}`}>
                                    </Trans>
                                </option>
                            )}
                        </MatesSelect>
                    </Grid>

                    <Grid item xs={12} md={6}>
                            <MatesTextField
                                name="minPrice"
                                label="Prezzo minimo"
                                variant="outlined"
                                control={this.props.control}
                                trigger={this.props.trigger}
                                formState={this.props.formState} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                            <MatesTextField
                                name="maxPrice"
                                label="Prezzo massimo"
                                variant="outlined"
                                control={this.props.control}
                                trigger={this.props.trigger}
                                formState={this.props.formState} />
                    </Grid>

                    <Grid item xs={12} md={12}>
                        <Stack direction="row" justifyContent="center" spacing={5}>
                            <MatesSwitch
                                name="divisible"
                                label="Divisibile"
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger} />
                            <MatesSwitch
                                name="airConditioning"
                                label="Aria condizionata"
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger} />
                            <MatesSwitch
                                name="parkingSlots"
                                label="Parcheggi"
                                formState={this.props.formState}
                                control={this.props.control}
                                trigger={this.props.trigger} />
                        </Stack>
                    </Grid>
                </Grid>
            </AdvancedSearchbar>
        )
    }
}

export default withUseFormHook<{}>(
    FavouritesAdvancedSearch,
    FavouritesAdvancedSearchSchema,
    new FavouritesAdvancedSearchForm(),
)
